<zimmerer-route-ion-wrapper class="ion-page">
  <!-- START -->
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center" *ngIf="!success && !fail">
    <div
      class="main-col noSlider withBottomPadding"
      [class.withTopPadding]="MobileService.isMobile"
      fxLayout="column"
      fxLayoutGap="20px"
    >
      <div fxLayout="column" fxLayoutGap="5px">
        <div style="text-align: center">Passwort zurücksetzen</div>
        <h2 class="listHeadline">Bitte gib dein neues Passwort ein</h2>
      </div>

      <div fxLayout="column" fxLayoutAlign="center center">
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center">
          <!-- password -->
          <mat-form-field>
            <input matInput type="password" placeholder="Passwort" formControlName="password" />
          </mat-form-field>

          <mat-error *ngIf="(form.controls.password.touched || submitted) && form.controls.password.errors">
            <div *ngIf="form.controls.password.errors.required">*Passwort ist ein Pflichtfeld</div>
            <div *ngIf="form.controls.password.errors.minlength">*Mindestlänge: 6 Zeichen</div>
          </mat-error>

          <!-- password_confirm -->
          <mat-form-field>
            <input
              matInput
              type="password"
              placeholder="Passwort wiederholen"
              formControlName="password_confirmation"
            />
          </mat-form-field>

          <mat-error *ngIf="(form.controls.password.touched || submitted) && form.errors">
            <div *ngIf="form.errors.passwordsDontMatch">Die Passwörter stimmen nicht überein</div>
          </mat-error>
        </form>

        <p>
          <button class="orange-button" (click)="send()">senden</button>
        </p>
      </div>
    </div>
  </div>

  <!-- SUCCESS -->
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center" *ngIf="success">
    <div
      class="main-col noSlider withBottomPadding"
      [class.withTopPadding]="MobileService.isMobile"
      fxLayout="column"
      fxLayoutGap="20px"
    >
      <h2>
        Dein neues Passwort ist gespeichert.<br />
        Du kannst dich jetzt damit anmelden.
      </h2>
    </div>
  </div>

  <!-- FAIL -->
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center" *ngIf="fail">
    <div
      class="main-col noSlider withBottomPadding"
      [class.withTopPadding]="MobileService.isMobile"
      fxLayout="column"
      fxLayoutGap="20px"
    >
      <h2>Das hat leider nicht geklappt.</h2>

      <div>
        Probiere am besten dir noch einmal eine Zurücksetz Mail zusenden zu lassen und den Vorgang noch einmal
        durchzuführen.
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
